import React from 'react';
import TextArea from '../FormElements/TextArea';
import TextInput from '../FormElements/TextInput';
import Select2DropdownList from '../FormElements/Select2DropdownList';
import GlobalErrorsBox from '../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import LoaderOverlay from '../LoaderOverlay/LoaderOverlay';

export default class UsersInviteCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			globalErrors: [],
			fieldErrors: null,
			loading: false,
			roles: null,
			emailAddresses: null
		};

		this.styleTextInputOnError = this.styleTextInputOnError.bind(this);
		this.buildEndpoint = this.buildEndpoint.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		// console.log('UsersInviteCard - Props', this.props);
		// console.log('UsersInviteCard - State', this.state);

		return (
			<div className="UsersInviteCard">
				<div className="card">
					<div className="card-body">
						<form onSubmit={this.onSubmit}>
							<section>
								<h1 className="card-title">{I18n.t('users_invite.title')}</h1>
								<div className="x-mark" onClick={this.props.onHidePopup}>
									<i className="fas fa-times" />
								</div>
							</section>
							<hr />
							<GlobalErrorsBox globalErrors={this.state.globalErrors} />
							<p className="lead-instructions">
								{I18n.t('users_invite.lead_instructions')}
							</p>
							<div>
								<h2 className="dropdown-label">
									{I18n.t('users_invite.role')}
								</h2>
								<div className="mb-3 invite-roles">
									<Select2DropdownList
										style={this.styleTextInputOnError('roles')}
										name="roles"
										placeholder={I18n.t('users_invite.role_placeholder')}
										endpoint={this.buildEndpoint()}
										onChange={this.onChange}
										fieldErrors={this.state.fieldErrors}
									/>
								</div>
								<h2 className="dropdown-label">
									{I18n.t('users_invite.emails')}
								</h2>
								<TextArea
									style={this.styleTextInputOnError('emailAddresses')}
									rows="4"
									name="emailAddresses"
									placeholder="Enter email addresses"
									value={this.state.emailAddresses}
									onChange={this.onChange}
									fieldErrors={this.state.fieldErrors}
									helperText={I18n.t('users_invite.email_instructions')}
								/>
							</div>
							<button
								type="submit"
								id="invite-button"
								className="btn btn-primary mt-3 mb-1"
							>
								{I18n.t('users_invite.send_user_invite')}
							</button>
						</form>
					</div>
				</div>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	buildEndpoint() {
		return `${this.props.iam_get_user_roles_endpoint}`;
	}

	onChange(event) {
		// console.log("event", event)
		const { name, value } = event.target;
		const { state } = this;
		state[name] = value;
		this.setState(state);
	}

	onSubmit(e) {
		// console.log('Sending invitations...');
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true
		});

		$.ajax({
			type: 'POST',
			url: this.props.iam_send_invitations_endpoint,
			data: {
				roles: this.state.roles,
				emailAddresses: this.state.emailAddresses
			},
			dataType: 'json'
		}).done((data) => {
			// console.log('Done!', data);
			if (data.status == 'success') {
				// console.log('Invitations successfully sent!', data);
				this.setState({
					loading: false
				});
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				// console.log('Invitations failed!');
				this.setState({
					loading: false,
					globalErrors: data.global_errors,
					fieldErrors: data.field_errors
				});
			}
		});
	}
}
